import "../asset_uploader.js";

window.ThumbnailEditor = window.ThumbnailEditor || {}; // VITE_MIGRATION: ensure namespace exists before submodule assignment
ThumbnailEditor.Uploader = class Uploader {
  constructor(options) {
    this.render = this.render.bind(this);
    this.reset = this.reset.bind(this);
    this._handleFileChanged = this._handleFileChanged.bind(this);
    this._handleProgress = this._handleProgress.bind(this);
    this._handleSuccess = this._handleSuccess.bind(this);
    this._handleFail = this._handleFail.bind(this);
    this._handleDrop = this._handleDrop.bind(this);
    this._uploadFile = this._uploadFile.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    this._addProgress = this._addProgress.bind(this);
    this._updateProgressBar = this._updateProgressBar.bind(this);
    this._removeProgessBar = this._removeProgessBar.bind(this);
    if (options == null) {
      options = {};
    }
    this.el = jQuery('<div class="thumbnail-editor-uploader">');
    this.label = jQuery("<p>Drop files here to upload</p><p>Or</p>");
    this.button = jQuery(
      '<label class="upload-thumbnail-button u-padding-left--s"><sp-icon name="upload-color" class="u-margin-right--xxs"></sp-icon>Upload Thumbnail</label>',
    );
    this.input = jQuery('<input type="file">');
    this.button.prepend(this.input);
    this.progressbar = jQuery(
      "<div class='progressbar-container'><span class='progressbar-file-name'></span><div class='progressbar-fill'><div class='progressbar-value' style='width: 0%;' /></div></div>",
    );

    this.isUploading = false;
    this.progressbar;
    this.detectFace = options.detectFace;
    this.uploadEndpoint = options.uploadEndpoint || "/admin/assets.json";

    this.uploader = new Sparkle.AssetUploader(
      {
        success: this._handleSuccess,
        error: this._handleFail,
        progress: this._handleProgress,
      },
      { endpoint: this.uploadEndpoint },
    );

    // BEHAVIOUR

    this.el.on("change", "input[type=file]", this._handleFileChanged);

    // Drag and Drop events

    // Prevents browsers default behaviour when dropping images on to a page
    this.el.on("dragover", false);

    this.el.on("dragenter", () => this.el.addClass("drag-over"));

    this.el.on("dragleave, dragend", () => this.el.removeClass("drag-over"));

    this.el.on("drop", this._handleDrop);
  }

  render() {
    this.reset();
    this.el.html(); // remove everything in the container
    this.el.append(this.label, this.button);
    return this;
  }

  // DSL

  reset() {
    return this.input.val("");
  }

  // EVENT HANDLERS

  _handleFileChanged(file) {
    if (this.isUploading) {
      return false;
    }
    return this._uploadFile(this.input.prop("files")[0]);
  }

  _handleProgress(event) {
    this._updateProgressBar(parseInt((event.loaded / event.total) * 100, 10));
    return this._triggerEvent("progress", { loaded: event.loaded, total: event.total });
  }

  _handleSuccess(assetJSON) {
    this._removeProgessBar();
    this.isUploading = false;
    return this._triggerEvent("success", assetJSON);
  }

  _handleFail() {
    this._removeProgessBar();
    this.isUploading = false;
    return this._triggerEvent("fail");
  }

  _handleDrop(event) {
    this.el.removeClass("drag-over");
    if (!this.isUploading) {
      this._uploadFile(event.originalEvent.dataTransfer.files[0]);
    }
    return false;
  }

  // HELPER FUNCTIONS

  _uploadFile(file) {
    this.isUploading = true;
    this._addProgress(file);
    if (file != null) {
      this.uploader.upload(file, { detectFace: this.detectFace });
    }
    return this._triggerEvent("begin", file);
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }

  _addProgress(file) {
    this.progressbar.find(".progressbar-file-name").html(file.name);
    return this.el.append(this.progressbar);
  }

  _updateProgressBar(percent) {
    return this.progressbar.find(".progressbar-value").css("width", percent + "%");
  }

  _removeProgessBar() {
    return this.progressbar.remove();
  }
};
